export default "__VITE_ASSET__BwLfMJo6__"